<script setup>
import { onMounted, watch, getCurrentInstance, nextTick } from "vue";
import { getFormattedDate } from '@/utils/helpers'
import { verLote } from "@/utils/subastaRedirections";


const props = defineProps({
  carteleraStore: Object,
  listadosEntidadesStore: Object
});

const lotes = props.carteleraStore?.lotes || {
  data: [],
  current_page: 1,
  per_page: 12,
  last_page: 1,
};

const { appContext } = getCurrentInstance();
const storage_path = appContext.config.globalProperties.storage_path;


onMounted(() => {
  let industrias = [...props.listadosEntidadesStore.industrias];
  industrias.sort((x, y) => x.nombre.localeCompare(y.nombre));
});



watch(
  () => lotes.current_page,
  (newPage) => {
    props.carteleraStore.updatePaginationLotes("current_page", newPage);
  }
);

watch(
  () => lotes.per_page,
  (newPerPage) => {
    props.carteleraStore.updatePaginationLotes("per_page", newPerPage);
  }
);

const goToPage = async (page) => {
  if (page > 0 && page <= lotes.last_page) {
    lotes.current_page = page;
    await nextTick();
    document
      .getElementById("carteleraLote")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

</script>

<template>

  <div class="row g-4" id="carteleraLote">

    <div v-if="(!lotes?.data || lotes.data.length === 0)" class="text-center py-5">
        <img src="@/assets/img/illustrations/sin_resultados.png" alt="Sin lotes" style="max-width: 280px;" class="mb-4">
        <h4 class="text-muted">No hay lotes disponibles.</h4> 
        <p class="text-muted fs-6">No hay lotes disponibles en este momento. <br>Te avisaremos cuando haya novedades.</p>
    </div>
    <a class="col-sm-2 col-lg-4" v-for="(lote, index) in lotes?.data || []" :key="index" href="javascript:;">
      <div class="card shadow-none hover-zoom">
        <div class="image-container">
          <div :id="`carousel-lotes-list-${lote.id}`" class="carousel slide" data-bs-ride="carousel"
            v-if="lote.multimedia.length > 0">
            <div class="carousel-inner">
              <div class="carousel-item" v-for="(multimedia, multimediaIndex) in lote.multimedia" :key="multimedia.id"
                :class="{ active: multimediaIndex === 0 }">
                <div class="lote-imagen w-100">
                  <!-- Imagen -->
                  <img v-if="multimedia?.tipo === 'imagen'"
                    :src="`${storage_path}/${multimedia.archivo?.hash}.${multimedia.archivo?.extension}`"
                    class="card-img-top" alt="Multimedia imagen" />

                  <!-- Video local -->
                  <video v-else-if="multimedia?.tipo === 'video'" muted playsinline controls
                    :src="`${storage_path}/${multimedia.archivo?.hash}.${multimedia.archivo?.extension}`"
                    class="card-img-top"></video>

                  <!-- Si no hay multimedia válida -->
                  <img v-else src="@/assets/img/logos/lote-sin-foto.png" class="card-img-top-default"
                    alt="Sin multimedia" style="width: 121px; height: 93px;" />
                </div>
              </div>
            </div>
            <!-- Botón Anterior -->
            <button class="carousel-control-prev" type="button" :data-bs-target="`#carousel-lotes-list-${lote.id}`"
              data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Anterior</span>
            </button>
            <!-- Botón Siguiente -->
            <button class="carousel-control-next" type="button" :data-bs-target="`#carousel-lotes-list-${lote.id}`"
              data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Siguiente</span>
            </button>
          </div>
          <div v-else class="no-image-placeholder">
            <i class="fa fa-image"></i>
            <p>Sin imagen disponible</p>
          </div>
        </div>
        <div class="card-body">
          <p class="fs-6 mb-2 text-truncate" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ lote.titulo }}
          </p>
          <p class="text-subtitulos-secondary mb-2 fs-13"><i class="fa fa-tag me-1 "></i> LOTE {{ lote.codintlote }}</p>
          <p class="text-subtitulos-secondary mb-2 fs-13"><i class="fa-regular fa-calendar fs-6 me-1"></i> {{
            getFormattedDate(lote.subasta?.fecha_hora_inicio) }}</p>
          <p class="text-subtitulos-secondary mb-2 fs-13"><i class="fa-regular fa-folder fs-6 me-1"></i> (ID {{
            lote.subasta?.external_id }}) </p>

          <button class="btn btn-outline-success w-100 mt-2" @click="verLote(lote.id)">Ver Lote</button>
        </div>
      </div>
    </a>
  </div>

  <!-- Paginador -->
  <div class="d-flex justify-content-center">
  <div class="d-flex justify-content-between align-items-center mt-3 px-3">
    <nav class="mt-3 " v-if="lotes.last_page > 1">
      <div class="custom-pagination w-100">
        <a href="#" @click.prevent="goToPage(lotes.current_page - 1)" class="page-nav"
          :class="{ disabled: lotes.current_page === 1 }">
          <i class="fa fa-chevron-left"></i> Anterior
        </a>

        <a v-for="page in lotes.last_page" :key="page" href="#" class="page-number fw-bold text-white"
          :class="{ active: page === lotes.current_page }" @click.prevent="goToPage(page)">
          {{ page }}
        </a>

        <a href="#" @click.prevent="goToPage(lotes.current_page + 1)" class="page-nav"
          :class="{ disabled: lotes.current_page === lotes.last_page }">
          Siguiente <i class="fa fa-chevron-right"></i>
        </a>
      </div>
    </nav>
  </div>
</div>


</template>
<style scoped>
.image-container {
  background-color: #f8f9fa;
  width: 100%;
  overflow: hidden;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.image-container .carousel,
.image-container .carousel-inner,
.image-container .carousel-item {
  height: 100%;
}

.image-container .carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  transform: scale(1.08);
  transform-origin: center;
}

.image-container .carousel-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.image-container .carousel-item iframe {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  border: none;
}

.no-image-placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #6c757d;
}

.no-image-placeholder i {
  font-size: 3rem;
}

.no-image-placeholder p {
  margin-top: 0.5rem;
  font-size: 0.9rem;
}

.image-container .carousel-control-prev,
.image-container .carousel-control-next {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 3;
}

.card:hover .image-container .carousel-control-prev,
.card:hover .image-container .carousel-control-next {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

@media (hover: none) {

  .image-container .carousel-control-prev,
  .image-container .carousel-control-next {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
}
</style>